
import {initWebComponent} from "@/helpers/web-component-helper";
import {LayerInfoFilterSettingsComponent} from "@/components/layer/info/filter/layer-info-filter-settings-component";
import {LayerInfoFilterResultComponent} from "@/components/layer/info/filter/layer-info-filter-result-component";
import {LayerInfoFilterResultButtonComponent} from "@/components/layer/info/filter/buttons/layer-info-filter-result-button-component";
import {
    LayerInfoFilterSettingsButtonComponent
} from "@/components/layer/info/filter/buttons/layer-info-filter-settings-button-component";
import {applyFilter, setActiveFilter, setFilterSettings} from "@/helpers/filter/filter-helper";
import {getFilters} from "@/http/services/http-services-filter";
import {
    addClassBySelector,
    getBySelector,
    hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import $ from "jquery";
import {resetFilter, setActiveFilterByFormID} from "@/helpers/filter/filter-settings-helper";
import DataTable from "datatables.net-bs5";
import 'datatables.net-scroller'
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.html5';
import {initDataTableSelector} from "@/helpers/datatable/datatable-selector-helper";


export class LayerInfoFilterSwitcherComponent extends HTMLElement {
    constructor(){
        super();

        let showClass = 'd-none'
        if(window.settings.ShowAllFilters === 2) {
            showClass = ''
        }

        getFilters().then((filters) => {

            if(filters.length === 0) {
                hideElementsBySelector('layer-info-filter-button')
                return
            } else {
                showElementsBySelector('layer-info-filter-button')
            }

            if(filters.find(filter => filter.form.ShowInSearchBar)) {
                getBySelector('header-filter').style.display = ''
            }

            window.filters = filters

            const template = document.createElement('template');
            let innerHTML = `
            <div class="card-body pl-2 pr-2 ${showClass}" id="divCardFilters">
            <div class="row mt-4">
                <div class="col-12">
                    <span id="tblFilterSettings_clear" class="fa fa-times position-absolute cursor-pointer d-none" style="right: 25px;top: -11px;z-index: 100;font-size:10px">
                    </span>
                    <table id="tblFilterSettings" style="width: 100%" class="nowrap table table-hover dataTable no-footer">
                        <thead>
                            <tr>
                                <th>Naam</th>
                            </th>
                        </thead>
                        <tbody>`
                     filters.map( (filter, key) => {
                         const form = filter.form

                         let name = filter.PresentationName + ' : '
                         if(window.settings.HidePresentationNameInFilter === 1) {
                             name = ''
                         }

                         innerHTML += `
                     <tr>
                        <td>                    
                            <div data-bookmark-presentation-id="${filter.BookmarkPresentationID}" data-form-id="${form.ID}" data-presentation-id="${filter.PresentationID}" value="${key}" class="list-group-item-action cursor-pointer">
                                ${name}${form.Name}
                            </div>
                        </td>
                    </tr>`
                     })
            innerHTML += `</tbody>
                     </table>
                     <select id="slcActiveFilter" size="1" class="custom-select d-none">
                        <option></option>`

                filters.map( (filter, key) => {
                    const form = filter.form

                    let name = filter.PresentationName + ' : '
                    if(window.settings.HidePresentationNameInFilter === 1) {
                        name = ''
                    }

                    innerHTML += `<option data-bookmark-presentation-id="${filter.BookmarkPresentationID}" data-form-id="${filter.FormID}" data-presentation-id="${filter.PresentationID}" value="` + key + `">${name}${form.Name}</option>`

                    if(form.ShowInSearchBar) {

                        let formID = filter.FormID
                        if(filter.FormLinkedID) {
                            formID = filter.FormLinkedID
                        }
                        getBySelector('#divFilterButtons').innerHTML +=
                            `<header-filter-item  
                            data-bookmark-presentation-id="${filter.BookmarkPresentationID}"
                            data-presentation-id="${filter.PresentationID}"
                            data-form-id="${formID}"
                            data-label="${name}${form.Name}"
                            data-test="header_filter_item">
                        </header-filter-item>`
                    }

                    form.form_attributes.map(formAttribute => {
                        if(formAttribute.ShowInSearchBar) {
                            getBySelector('header-search').querySelector('.dropdown-menu').innerHTML +=
                                `<li data-form-attribute-id="${formAttribute.ID}" data-filter-key="${key}" class="dropdown-item cursor-pointer liHomeFindAdressType">${filter.PresentationName} : ${formAttribute.attribute.Display}</li>`
                        }
                    })
                })

innerHTML +=  `</select>
        </div>
       </div>
     </div>
     
    <div class="nav nav-tabs scrollmenu mb-2" id="divActiveFilters" data-testid="div_active_filters">
    </div>

   <button id="btnShowFilterLayers" class="btn btn-outline-secondary d-none btn-sm borderless float-right mr-2 d-none" style="margin-top: 7px;">
        <span class="fa fa-chevron-left"></span> Filters
    </button>
    
             <div class="card-header p-2 divFilterSwitcher d-none">
                  <layer-info-filter-settings-button class=""></layer-info-filter-settings-button>
                  <layer-info-filter-result-button class="d-none ml-2"></layer-info-filter-result-button>
              </div>
`;

            template.innerHTML = innerHTML

            initWebComponent(this, template)

            initDataTableSelector('tblFilterSettings')

            this.querySelectorAll('.list-group-item-action').forEach((element) => {
                element.addEventListener('click', (event) => {
                    const selected = event.target.dataset
                    if(selected.bookmarkPresentationId) {
                        showElementsBySelector('layer-info-filter .btnCloseInfoMenu')
                        showElementsBySelector('layer-info-filter .btnHideInfoMenu')

                        setActiveFilter(selected.bookmarkPresentationId, selected.presentationId, selected.formId)

                        showElementsBySelector('#btnShowFilterLayers')
                    }

                    addClassBySelector('layer-info-filter-button .info-menu-btn', 'active')
                })
            })

            this.querySelector('#divActiveFilters').addEventListener('click', (event) => {
                if(event.target.tagName === 'A') {
                    setActiveFilterByFormID(event.target.dataset.id)

                    removeClassBySelector('.nav-link-filter-header', 'active')
                    event.target.classList.add('active')
                }
            })

            if(!window.chrome) {
                this.querySelector('#tblFilterSettings_clear').addEventListener('click', (event) => {
                    window['tblFilterSettings'].search('').draw();
                    hideElementsBySelector('#tblFilterSettings_clear')
                })
            }


            if(window.urlParamsObject.filter) {
                setActiveFilter(undefined, undefined, undefined, 'WMS eenvoudig', window.urlParamsObject.filter)
                applyFilter()
            }

            document.getElementById('btnShowFilterLayers').addEventListener('click', () => {
                resetFilter()
            })
        })

    }
}
